import React from 'react';
import './index.scss';


const Home = (props) => {

  React.useEffect(_ => {
    if (props.authenticated) props.history.push("/dashboard");

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  return (
    <div className='wrapper'>
      <h1>
        Bem vindo ao Gestor do App Sebrae
      </h1>
      <div className='container-info'>
        <h2>
          Aqui o gestor é capaz de configurar o melhor uso do aplicativo <strong>Sebrae na palma</strong>, limitando e possibilitando o acesso
          de acordo com as necessidades e interesses.

        </h2>
      </div>
      <img src='/app.png' alt='Imagem de logo do sebrae' />
      <h2> Se também lhe interessa o domínio do sistema , entre em contato através do e-mail <strong>marcio@sebrae.com.br.</strong></h2>
    </div>
  )
}

export default Home;
